import ServiceExec from '@/common/utils/ServiceExec';
import { bizmoneyAPI } from '@/common/service/ApiList';

export default {
  async bizmoneyChargeRequest({ commit, state }, payload) {
    const { data, status } = await ServiceExec.post(
      bizmoneyAPI.bizmoney_charge,
      payload
    );
    if (status === 200) return data;
  },

  // 상점관리자 - 거래내역 리스트
  async bizmoneyTransactionList({ commit, state }, payload) {
    const { page, totalPage, limit } = state;
    if (page > totalPage) return;

    const { data, status } = await ServiceExec.get(
      bizmoneyAPI.bizmoney_transaction_list,
      { ...payload, page, limit }
    );

    const { pageInfo, list } = data;

    commit('setPage', page + 1);
    commit('setTotalPage', pageInfo?.totalPage ?? 2);
    commit('setList', list ?? []);
  },

  // 상점관리자 - 비즈머니 충전 요청 리스트
  async bizmoneyRequestList({ commit, state }, payload) {
    const { page, totalPage, limit } = state;
    if (page > totalPage) return;

    const { data, status } = await ServiceExec.get(
      bizmoneyAPI.bizmoney_request_list,
      { ...payload, page, limit }
    );

    const { pageInfo, list } = data;

    commit('setPage', page + 1);
    commit('setTotalPage', pageInfo?.totalPage ?? 2);
    commit('setList', list ?? []);
  }
};
